export const createUser = `mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      id
      authMethod
      accountClaimId
      accountClaim {
        id
        active
        eligible
        employeeId
        firstName
        lastName
        dateOfBirth
        title
        department
        atsId
        middleName
        isRehire
      }
      careerProfile
      cognitoId
      jobMatches {
        id
        active
        contactId
        userId
        jobId
        job {
          id
          companyId
          company {
            id
            name
          }
          subCompanyId
          subCompany {
            companyId
            id
            logo {
              bucket
              key
              region
            }
            name
          }
          title
          internalJobLink
          location
          departmentId
          department {
            id
            name
          }
          hideImInterested
          isGeneralReferral
          status
          referrals {
            id
            companyId
            company {
              id
              name
            }
            contactId
            userId
            jobId
            status
          }
        }
        matchStatus
        relevance
        dateCreated
      }
      companyId
      company {
        id
        name
        defaultBonusAmount
        contactIncentiveBonus
        websiteUrl
        dashboardReferralPolicyText
        referralBonusWaitingPeriod
        bonusEarnedNote
        allowSelfReferrals
        allowInternalMobility
        internalMobilityImage {
          bucket
          region
          key
        }
        dateCreated
        brandColor
        accountType
        logo {
          bucket
          region
          key
        }
        disableSmartReferrals
        disableSAMLLogin
        disableClaimYourAccountLogin
        confirmCompliance
        ssoGoogleDomain
        confirmContactEmails
        whiteLabel
        stages
        API {
          googleClientId
          microsoftClientId
        }
        theme
        symbol {
          bucket
          region
          key
        }
        background {
          bucket
          region
          key
        }
        errorImage {
          bucket
          region
          key
        }
        socialImage {
          bucket
          region
          key
        }
        subCompanies {
          companyId
          id
          name
          keywords
        }
        departments {
          companyId
          id
          name
          keywords
        }
        userGroups {
          companyId
          id
          name
          keywords
        }
        enableGeneralReferrals
        referralStatus
        referralCustomStatuses
        disableManagerPermissions
        hideJobsPage
        disableShareLink
        disableNewReferralSMSNotification
        helpUrl
        privacyUrl
        termsUrl
        linkUrl
        linkName
        enableProspectCreation
        allowSelfReferralsInternalLink
        sendAdminNotificationsOnReferral
        sendAdminNotificationsOnInternalCandidatesFound
        enableAcceptedReferralReminder
        disableExtendedUserJobsView
        enableExtendedNetwork
        enableCareerProfile
        enableJobMatching
        externalUserSignUp
        hideLoginForm
        disableReferrals
        hideBonus
        includeAdminInRanking
        disableSite
        hideInterestedForGroup
        senderEmailAddress
        whiteLabelServiceName
        host
        hideShareLinkForDepartment
        hideShareLinkNoPublicUrl
        hideDateCreatedJobDetails
        subCompanyLabel
        labelDepartment
        sftpFolderName
        defaultLocation
        labelEmployeeID
        giftCardStoreAPIKeys {
          apiKey
          region
        }
        giftCardStoreBalance
        giftCardStorePendingBalance
        enableCustomDashboard
        enableCustomNav
        customNav
			  customDashboard
        publicLeaderboard
        hideReferralsRanking
        pointsSettings
        popupTitle
        popupTitleContent
        hideWhatsApp
        hideRecruiterInfo
        hideRecruiterInfoJobDetails
        resetPopup
        defaultToSubcompany
        internalMobilityCustomTitle
        appStoreUrls {
          ios
          android
        }
      }
      contacts {
        id
        firstName
        lastName
        importMethod
        emailAddress
        phoneNumber
      }
      emailAddress
      employeeType
      role
      firstName
      lastName
      title
      avatar {
        bucket
        region
        key
      }
      departmentId
      department {
        id
        name
      }
      extendedCompanies
      extendedCompaniesData {
        id
        name
        disableExtendedUserJobsView
        enableExtendedNetwork
        enableCareerProfile
        enableJobMatching
      }
      extendedContactIds
      extendedContactData {
        id
        firstName
        lastName
        importMethod
        emailAddress
        phoneNumber
        extendedUserId
        userId
        user {
          id
          cognitoId
          firstName
          lastName
          emailAddress
          companyId
        }
        jobMatches {
          id
          contactId
          userId
          jobId
          job {
            id
            companyId
            company {
              id
              name
            }
            subCompanyId
            title
            location
            departmentId
            department {
              id
              name
            }
            hideImInterested
            isGeneralReferral
            status
            referrals {
              id
              companyId
              company {
                id
                name
              }
              contactId
              userId
              jobId
              status
            }
          }
          matchStatus
          relevance
          dateCreated
        }
        referrals {
          id
          bonuses {
            id
            amountDue
            bonusStatus
            companyId
            contactId
            earnedDate
            hireDate
            jobId
            payment
            recipientType
            referralId
            startDate
            userId
            notes
          }
          companyId
          company {
            id
            name
          }
          contactId
          contact {
            id
            emailAddress
            lastName
            firstName
            socialMediaAccounts
            phoneNumber
          }
          userId
          user {
            id
            cognitoId
            firstName
            lastName
            incentiveEligible
            userGroupId
            userGroup {
              id
              measurement
              name
              currency
            }
          }
          jobId
          job {
            id
            title
            createdById
            createdBy {
              id
              firstName
              lastName
            }
            location
            departmentId
            department {
              id
              name
            }
            referralBonus
          }
          note
          message
          hireDate
          referralDate
          referralType
          status
          questionsData
          bonusStatus
          contactResume {
            bucket
            region
            key
          }
        }
      }
      userGroupId
      userGroup {
        id
        measurement
        name
        currency
        languageCode
      }
      jobClassId
      jobClassName
      jobFamilyGroupId
      jobFamilyGroupName
      jobFamilyId
      jobFamilyName
      jobProfileId
      jobProfileName
      lastLogin
      lastNotificationCheck
      incentiveEligible
      inviteStatus
      totalReferrals
      active
      managedDepartments {
        departmentId
        department {
          id
          name
        }
      }
      connectedApps
      location
      currency
      createdById
      languageCode
      dateFormat
      isAllowJobNotification
      defaultDistance
      subCompanyId
      subCompany {
        companyId
        id
        logo {
          bucket
          key
          region
        }
        name
      }
      accessToken
      expires
      expirationDoneByToken
    }
}`;
